module.exports = __webpack_public_path__ + "static/dg2-d552fe4b6de7ade16d44cb9054f34c72.jpg";